// extracted by mini-css-extract-plugin
module.exports = {"subitle":"styles_subitle__3DCzB"};